import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { string, shape, arrayOf, number, bool } from 'prop-types';
import Carousel from '@magalu/stereo-ui/molecules/Carousel';
import { Link } from '@magalu/stereo-ui/atoms';
import { BannerContainer, Image, ImageWrapper } from './SellerPageBanner.styles';
import { buildSearchUrl } from './utils';
var SellerPageBanner = function SellerPageBanner(_ref) {
  var staticProps = _ref["static"];
  var height = staticProps.height,
    path = staticProps.path,
    position = staticProps.position,
    _staticProps$banners = staticProps.banners,
    banners = _staticProps$banners === void 0 ? [] : _staticProps$banners,
    fallbackImage = staticProps.fallbackImage,
    _staticProps$duration = staticProps.duration,
    duration = _staticProps$duration === void 0 ? 2000 : _staticProps$duration,
    _staticProps$interval = staticProps.interval,
    interval = _staticProps$interval === void 0 ? 3000 : _staticProps$interval,
    _staticProps$auto = staticProps.auto,
    auto = _staticProps$auto === void 0 ? true : _staticProps$auto,
    sellerId = staticProps.sellerId,
    baseUrl = staticProps.baseUrl;
  var firstBanner = Array.isArray(banners) && banners.length > 0 ? banners[0] : null;
  var linkUrl = firstBanner && sellerId ? buildSearchUrl(sellerId, firstBanner, baseUrl) : path;
  var imageProps = {
    height: height,
    position: position
  };
  var images = [];
  if (Array.isArray(banners) && banners.length > 0) {
    images = banners.map(function (banner) {
      var _banner$images;
      return banner == null ? void 0 : (_banner$images = banner.images) == null ? void 0 : _banner$images.desktop;
    }).filter(Boolean);
  }
  if (images.length === 0 && fallbackImage) {
    images = [fallbackImage];
  }
  if (images.length === 0) {
    return null;
  }
  var showCarousel = images.length > 1;
  return React.createElement(BannerContainer, {
    "data-testId": "banner-seller"
  }, React.createElement(Carousel, {
    auto: showCarousel ? auto : false,
    gutter: 0,
    insideControls: true,
    interval: interval,
    "data-testid": "banner-seller-carousel",
    showArrowControls: true,
    showControls: false,
    showSlideCount: false,
    transitionDuration: duration
  }, images.map(function (imageSrc) {
    return React.createElement(Link, {
      "data-testId": "banner-seller-link",
      href: linkUrl,
      style: {
        display: 'block',
        width: '100%'
      },
      key: "banner-".concat(imageSrc),
      "aria-label": "Link do banner"
    }, React.createElement(ImageWrapper, {
      height: height
    }, React.createElement(Image, _extends({
      alt: "Banner p\xE1gina do seller: ".concat(imageSrc),
      key: "banner-".concat(imageSrc)
    }, imageProps, {
      src: imageSrc
    }))));
  })));
};
process.env.NODE_ENV !== "production" ? SellerPageBanner.propTypes = {
  "static": shape({
    auto: bool,
    banners: arrayOf(shape({
      brand: shape({
        label: string,
        slug: string
      }),
      category: shape({
        description: string,
        id: string,
        label: string,
        title: string
      }),
      images: shape({
        desktop: string,
        mobile: string
      }),
      subCategory: shape({
        description: string,
        id: string,
        label: string,
        title: string
      })
    })),
    baseUrl: string,
    duration: number,
    fallbackImage: string,
    height: string.isRequired,
    interval: number,
    path: string.isRequired,
    position: string.isRequired,
    sellerId: string
  })
} : void 0;
SellerPageBanner.defaultProps = {
  "static": {}
};
export default SellerPageBanner;